export function downloadFile({ data, fileName, type }) {
  const a = document.createElement('a');

  let blob;
  switch (type) {
    case 'blob':
      blob = data;
      break;
    case 'pdf':
      blob = new Blob([data], { type: 'application/pdf' });
      break;
    case 'csv':
      const csvContent = `data:text/csv;charset=utf-8,${data}`;
      a.href = encodeURI(csvContent);
      break;
    case 'zip':
      blob = new Blob([data], { type: 'application/zip' });
      break;
    default:
      throw new Error('Invalid file type');
  }

  if (blob) {
    a.href = window.URL.createObjectURL(blob);
  }

  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  return {};
}
